import React, { FunctionComponent } from 'react';
import { Card, Text } from '@mlc/web-ui-toolkit';
import { asPercentage, asNumber } from '../../../../../common/formatter';
import planProfileTestIds from '../../PlanProfile.elements';
type Props = {
	activeChoice: number;
	defaultOption: number;
};

const Percentage: FunctionComponent<Props> = ({
	activeChoice,
	defaultOption,
}) => {
	const percentTotal: number = asNumber(activeChoice) + asNumber(defaultOption);

	if (percentTotal == 100) {
		return (
			<>
				<Text fontWeight="semibold" marginTop={6} marginBottom={4} el="h5">
					Investment Choice by Percentage of Members
				</Text>
				<Text
					margin={0}
					data-id={planProfileTestIds.planDefaultInvestmentOption}
					el="p"
				>
					Default investment option:{' '}
					<Text fontWeight="semibold">
						{asPercentage(defaultOption, false)}
					</Text>
				</Text>
				<Text
					margin={0}
					marginTop={4}
					marginBottom={6}
					data-id={planProfileTestIds.planActiveChoiceOption}
					el="p"
				>
					Active choice:{' '}
					<Text fontWeight="semibold">{asPercentage(activeChoice, false)}</Text>
				</Text>
			</>
		);
	} else {
		return (
			<>
				<Text fontWeight="semibold" marginTop={6} el="h5">
					Investment Choice by Percentage of Members
				</Text>
				<Text
					margin={0}
					data-id={planProfileTestIds.planDefaultInvestmentOption}
					el="p"
				>
					Default investment option: <Text fontWeight="semibold">0%</Text>
				</Text>
				<Text
					margin={0}
					marginTop={4}
					marginBottom={6}
					data-id={planProfileTestIds.planActiveChoiceOption}
					el="p"
				>
					Active choice: <Text fontWeight="semibold">0%</Text>
				</Text>
			</>
		);
	}
};

export default Percentage;
